import { render, staticRenderFns } from "./ManufacturerFilter.vue?vue&type=template&id=7a2b8231&scoped=true&"
import script from "./ManufacturerFilter.vue?vue&type=script&lang=js&"
export * from "./ManufacturerFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2b8231",
  null
  
)

export default component.exports